'use client';

var DEFAULT_FLOATING_CONFIG = {
    placement: 'bottom-start',
    position: 'absolute',
    enablePortal: false,
    useWindowAsFlippingContainer: false,
    isFlip: true
};
var DEFAULT_STYLE_OPTION = {
    isFlex: false,
    placeholderColor: '#999',
    isShowSecondaryBtn: true,
    primaryBtnType: 'primary',
    secondaryBtnType: 'default'
};
var DEFAULT_SELECT_OPTIONS = {
    isSingleSelect: false,
    displayAsPopup: false,
    hiddenFooter: false
};
var DEFAULT_TEXT_OPTIONS = {
    placeholder: '',
    primaryBtnText: '',
    secondaryBtnText: ''
};
var VIEWINDEX;
(function (VIEWINDEX) {
    VIEWINDEX[VIEWINDEX["LEFT"] = 0] = "LEFT";
    VIEWINDEX[VIEWINDEX["RIGHT"] = 1] = "RIGHT";
})(VIEWINDEX || (VIEWINDEX = {}));
var KEYCODE;
(function (KEYCODE) {
    KEYCODE["SPACE"] = "Space";
    KEYCODE["ARROW_RIGHT"] = "ArrowRight";
})(KEYCODE || (KEYCODE = {}));
var OTHER_PARENT_ID = 30;
var QUERY_SELECTOR_FIRST_RIGHT_ELEMENT = '[data-cname="dropdown__body__rightColumn"] [data-id="-1"]';

export { DEFAULT_FLOATING_CONFIG, DEFAULT_SELECT_OPTIONS, DEFAULT_STYLE_OPTION, DEFAULT_TEXT_OPTIONS, KEYCODE, OTHER_PARENT_ID, QUERY_SELECTOR_FIRST_RIGHT_ELEMENT, VIEWINDEX };
//# sourceMappingURL=constants.js.map
